import { render, staticRenderFns } from "./SelectSchoolDlg.vue?vue&type=template&id=da9d9c84&scoped=true&"
import script from "./SelectSchoolDlg.vue?vue&type=script&lang=js&"
export * from "./SelectSchoolDlg.vue?vue&type=script&lang=js&"
import style0 from "./SelectSchoolDlg.vue?vue&type=style&index=0&id=da9d9c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9d9c84",
  null
  
)

export default component.exports